import { IconButton } from '@material-ui/core';
import React, { useState } from 'react';
import './Manual.scss';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import Card from 'component/Card';

interface ManualContent {
  index: number;
  content: string;
  image?: string;
}
const manualContents: ManualContent[] = [
  {
    index: 0,
    content: '시작하기를 누른 후에,',
  },
  {
    index: 1,
    content: '\'파일 업로드\'를 눌러 이미지 파일을 업로드합니다.',
  },
  {
    index: 2,
    content: '그리고 \'앨범 만들기\'를 클릭하고 \'f11\'을 눌러 \n전체화면으로 만들면 끝~',
  },
];

function Manual(): JSX.Element {
  const [ activeIndex, setActiveIndex ] = useState(0);
  const [ visibleLeftButton, setVisibleLeftButton ] = useState(false);
  const [ visibleRightButton, setVisibleRightButton ] = useState(true);

  const onClickRightArrow = () => {
    if (activeIndex === manualContents.length - 1) {
      return;
    }

    setActiveIndex(activeIndex + 1);
    if (!visibleLeftButton) {
      setVisibleLeftButton(true);
    }
    if (activeIndex + 1 === manualContents.length - 1) {
      setVisibleRightButton(false);
    }
  };

  const onClickLeftArrow = () => {
    if (activeIndex === 0) {
      return;
    }

    setActiveIndex(activeIndex - 1);
    if (!visibleRightButton) {
      setVisibleRightButton(true);
    }
    if (activeIndex - 1 === 0) {
      setVisibleLeftButton(false);
    }
  };

  return (
    <article className="manual">
      <IconButton className={visibleLeftButton ? '' : 'hidden'} aria-label="left" onClick={onClickLeftArrow}>
        <ChevronLeft />
      </IconButton>
      <div className="card-container" style={{ left: -activeIndex * 320 }}>
        { manualContents.map((c) => (
          <Card key={c.index} className={`manual-card ${c.index === activeIndex ? 'active' : ''}`}>
            <p>{c.content}</p>
          </Card>
        ))}
      </div>
      <IconButton className={visibleRightButton ? '' : 'hidden'} aria-label="right" onClick={onClickRightArrow}>
        <ChevronRight />
      </IconButton>
    </article>
  );
}

export default Manual;
